import { ColumnDef } from "@tanstack/react-table";
import ActionButton from "../ActionButton";
import { MembershipPlansProps } from "../../store/actionType";

export const TableColumns: ColumnDef<MembershipPlansProps>[] = [
  {
    accessorFn: (row) => row?.membership_details?.package.name,
    id: "package_name",
    cell: (info) => info.getValue(),
    header: () => <span>Package Name</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.membership_details?.duration_type,
    id: "duration_type",
    cell: (info) => info.getValue(),
    header: () => <span>Duration Type</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.user_id,
    id: "user_id",
    cell: (info) => info.getValue(),
    header: () => <span>User Id</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.membership_join_date,
    id: "membership_join_date",
    cell: (info) => info.getValue(),
    header: () => <span>Join Date</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.membership_end_date,
    id: "membership_end_date",
    cell: (info) => info.getValue(),
    header: () => <span>End Date</span>,
    filterFn: "equalsString",
  },
  {
    id: "action",
    cell: ({ row }) => {
      return (
        <div className="flex justify-center items-center gap-2">
          <ActionButton items={row.original} />
        </div>
      );
    },
    header: () => <span>Actions</span>,
    enableSorting: false,
  },
];
